import { AppDispatch } from "./store";
import { useDispatch } from "react-redux";

// Use instead of plain useDispatch to dispatch thunks, e.g. RTK Query cache
// updates
export const useAppDispatch: () => AppDispatch = useDispatch;
